import pathName, { USER_TXT } from '../../routing/pathName.constant'
import { userWiseRole } from '../../utils/constant'
import {
  AdminIcon,
  CatalogueMenuIcon,
  ClipboardIcon,
  ContractorIcon,
  CustomerIcon,
  DashboardIcon,
  DataviewIcon,
  DealerIcon,
  DigitalRetailerIcon,
  FieldEngineerIcon,
  HomeIcon,
  ProductManufactureIcon,
  ReportIcon,
  TransportContractorIcon,
  UserIcon,
} from '../../utils/icons'
import { userRelationKey } from '../userManagement/user.description'

const {
  HOME,
  ADMIN,
  CONTRACTOR,
  CUSTOMER,
  DEALER,
  DEALER_USER,
  DIGITAL_RETAILER,
  FIELD_ENGINEER,
  PRODUCT_MANUFACTURE,
  TRANSPORTER,
  DATA_VISUALIZATION,
  CATALOGUE,
  JOBS,
  DASHBOARD,
} = pathName

const {
  admin,
  productManufacture,
  digitalRetailer,
  dealer,
  dealerUser,
  contractor,
  fieldEngineer,
  customer,
  transporter,
} = userWiseRole

const { associate } = userRelationKey

const allUser = [
  admin,
  productManufacture,
  digitalRetailer,
  dealer,
  dealerUser,
  contractor,
  fieldEngineer,
  customer,
  transporter,
]

const userChildrenList = [
  {
    key: ADMIN,
    userId: admin,
    Icon: AdminIcon,
    label: 'user_Admin',
    sidebar: allUser,
    addEdit: [admin],
    level: { menu: allUser },
    userView: {
      user_ProductManufacturer: [
        {
          payload: { roleId: productManufacture },
        },
      ],
      user_DigitalRetailer: [{ payload: { roleId: digitalRetailer } }],
      user_Dealer: [{ payload: { roleId: dealer } }],
      user_Customer: [{ payload: { roleId: customer } }],
      user_Transporter: [{ payload: { roleId: transporter } }],
    },
  },
  {
    key: PRODUCT_MANUFACTURE,
    userId: productManufacture,
    Icon: ProductManufactureIcon,
    label: 'user_ProductManufacturer',
    sidebar: [admin, digitalRetailer],
    addEdit: [admin],
    level: { menu: [admin, contractor, dealer] },
    userView: {
      user_AssociatedDigitalRetailerList: [
        {
          payload: { roleId: digitalRetailer, relationType: associate },
          addAssociate: [admin],
        },
      ],
    },
    parent: { label: 'user_Admin', id: admin },
  },
  {
    key: DIGITAL_RETAILER,
    userId: digitalRetailer,
    Icon: DigitalRetailerIcon,
    label: 'user_DigitalRetailer',
    sidebar: [admin, productManufacture, dealer, dealerUser],
    addEdit: [admin],
    level: { menu: [admin, contractor, dealer] },
    userView: {
      user_AssociatedProductManufacturerList: [
        {
          payload: { roleId: productManufacture, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedDealerList: [
        {
          payload: { roleId: dealer, relationType: associate },
          addAssociate: [admin],
        },
      ],
    },
    parent: { label: 'user_Admin', id: admin },
  },
  {
    key: DEALER,
    userId: dealer,
    Icon: DealerIcon,
    label: 'user_Dealer',
    sidebar: [admin, contractor, dealerUser, fieldEngineer, digitalRetailer],
    addEdit: [admin],
    level: { menu: [admin, contractor, dealer] },
    userView: {
      user_AssociatedDigitalRetailerList: [
        {
          payload: { roleId: digitalRetailer, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_ServiceManager: [{ payload: { roleId: dealerUser } }],
      user_Contractor: [
        {
          payload: { roleId: contractor },
          subTitle: 'user_InHouseTeam',
        },
        {
          payload: { roleId: contractor, relationType: associate },
          subTitle: 'user_ServiceChampion',
          addAssociate: [admin],
        },
      ],
      user_Customer: [
        {
          payload: { roleId: customer },
          addAssociate: [admin],
        },
      ],
    },
    parent: { label: 'user_Admin', id: admin },
  },
  {
    key: DEALER_USER,
    userId: dealerUser,
    Icon: DealerIcon,
    label: 'user_ServiceManager',
    sidebar: [admin, dealer],
    addEdit: [admin, dealer],
    level: {
      menu: [dealer],
      'sub-menu': [admin],
    },
    userView: {
      user_Dealer: [{ payload: { roleId: dealer } }],
      user_AssociatedDigitalRetailerList: [
        {
          payload: { roleId: digitalRetailer, relationType: associate },
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_Contractor: [
        {
          payload: { roleId: contractor },
          subTitle: 'user_InHouseTeam',
          needParent: true,
        },
        {
          payload: { roleId: contractor, relationType: associate },
          subTitle: 'user_ServiceChampion',
          addAssociate: [admin],
          needParent: true,
        },
      ],
      user_Customer: [
        {
          payload: { roleId: customer },
          addAssociate: [admin],
          needParent: true,
        },
      ],
    },
    parent: { label: 'user_Dealer', id: dealer },
  },
  {
    key: CONTRACTOR,
    userId: contractor,
    Icon: ContractorIcon,
    label: 'user_Contractor',
    sidebar: [admin, dealer, dealerUser, customer, transporter, fieldEngineer],
    addEdit: [admin, dealer, dealerUser],
    level: {
      menu: [dealer],
      'sub-menu': [admin, contractor, dealerUser],
    },
    userView: {
      user_Dealer: [
        { payload: { roleId: dealer }, subTitle: 'user_Parent' },
        {
          payload: { roleId: dealer, relationType: associate },
          subTitle: 'user_Associate',
          addAssociate: [admin],
        },
      ],
      user_Technician: [{ payload: { roleId: fieldEngineer } }],
      user_Customer: [
        {
          payload: { roleId: customer },
          addAssociate: [admin],
        },
      ],
      user_Transporter: [
        {
          payload: { roleId: transporter, relationType: associate },
          addAssociate: [admin],
        },
      ],
    },
    parent: { label: 'user_Dealer', id: dealer },
  },
  {
    key: FIELD_ENGINEER,
    userId: fieldEngineer,
    Icon: FieldEngineerIcon,
    label: 'user_Technician',
    sidebar: [admin, contractor],
    addEdit: [admin, contractor],
    className: 'sub-menu',
    level: {
      menu: [contractor],
      'sub-menu2': [admin],
    },
    userView: {
      user_Contractor: [{ payload: { roleId: contractor } }],
      user_Dealer: [
        {
          payload: { roleId: dealer },
          subTitle: 'user_Parent',
          needParent: true,
        },
        {
          payload: { roleId: dealer, relationType: associate },
          addAssociate: [admin],
          subTitle: 'user_Associate',
          needParent: true,
        },
      ],
      user_Customer: [
        {
          payload: {
            roleId: customer,
          },
          needParent: true,
        },
      ],
      user_Transporter: [
        {
          payload: { roleId: transporter, relationType: associate },
          needParent: true,
        },
      ],
    },
    parent: { label: 'user_Contractor', id: contractor },
  },
  {
    key: CUSTOMER,
    userId: customer,
    Icon: CustomerIcon,
    label: 'user_Customer',
    sidebar: [admin, dealer, contractor, dealerUser, fieldEngineer],
    addEdit: [admin],
    level: { menu: [admin, contractor, dealer] },
    userView: {
      user_AssociatedDealerList: [
        {
          payload: { roleId: dealer, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_AssociatedContractor: [
        {
          payload: { roleId: contractor, relationType: associate },
          addAssociate: [admin],
        },
      ],
      user_Building: [{ payload: {}, isBuilding: true, addEdit: true }],
    },
    parent: { label: 'user_Admin', id: admin },
  },
  {
    key: TRANSPORTER,
    userId: transporter,
    Icon: TransportContractorIcon,
    label: 'user_Transporter',
    sidebar: [admin, contractor, fieldEngineer],
    addEdit: [admin],
    level: { menu: [admin, contractor, dealer] },
    userView: {
      user_AssociatedContractor: [
        {
          payload: { roleId: contractor, relationType: associate },
          addAssociate: [admin],
        },
      ],
    },
    parent: { label: 'user_Admin', id: admin },
  },
]

const sidebarMenus = [
  {
    key: HOME,
    Icon: HomeIcon,
    label: 'menu_Home',
    sidebar: allUser,
  },
  {
    key: DASHBOARD,
    Icon: DashboardIcon,
    label: 'menu_Dashboard',
    sidebar: allUser,
  },
  {
    key: USER_TXT,
    Icon: UserIcon,
    label: 'menu_User',
    sidebar: allUser,
    children: userChildrenList,
  },
  {
    key: JOBS,
    Icon: ClipboardIcon,
    label: 'menu_Jobs',
    sidebar: [
      admin,
      productManufacture,
      dealer,
      dealerUser,
      contractor,
      fieldEngineer,
      digitalRetailer,
    ],
    addEdit: [dealer, dealerUser, contractor, fieldEngineer],
  },
  {
    key: CATALOGUE,
    Icon: CatalogueMenuIcon,
    label: 'menu_CatalogueManagement',
    sidebar: allUser,
    addEdit: [admin],
  },
  {
    key: 'report',
    Icon: ReportIcon,
    label: 'menu_Report',
    disabled: true,
    sidebar: [
      admin,
      productManufacture,
      dealer,
      dealerUser,
      contractor,
      fieldEngineer,
    ],
  },
  {
    key: 'dataView',
    Icon: DataviewIcon,
    label: 'menu_DataView',
    disabled: true,
    sidebar: [
      admin,
      productManufacture,
      dealer,
      dealerUser,
      contractor,
      fieldEngineer,
    ],
  },
  {
    key: DATA_VISUALIZATION,
    Icon: DataviewIcon,
    label: 'menu_DataViz',
    disabled: false,
    sidebar: [admin, dealer, dealerUser, contractor, fieldEngineer],
  },
]

export { sidebarMenus, userChildrenList }
